import axios from "axios";
import RestApi from "../../../utils/RestApi";
import { LiveEvents } from '../model/LiveEvents';
import { WebSocketApi } from "./WebSocketApi";

export class LiveDataApi {
    public async getHistoricLiveData(fixtureId: number, legacy: boolean): Promise<LiveEvents.HistoricLiveEvents> {
        let url: string;
        if(legacy) {
            url = await RestApi.getUrl(`/v1/liveapi/historic/${fixtureId}`)
        } else {
            url = await RestApi.getUrl(`/v2/live/historic/${fixtureId}`)
        }
        const result = await axios.get(url);
        if (result.status !== 200) {
            throw new Error("Getting historic live data failed");
        }
        return result.data as LiveEvents.HistoricLiveEvents;
    }

    public getLiveDataSocket(fixtureId: number, legacy: boolean): WebSocketApi {
        return new WebSocketApi(fixtureId, legacy);
    }
}

export default new LiveDataApi();
